import { combineReducers } from 'redux';

import { ordersGraph } from 'features/dashboard/redux/reducers/ordersGraph';
import { redemptionsGraph } from 'features/dashboard/redux/reducers/redemptionsGraph';
import { summaryReducer } from 'features/dashboard/redux/reducers/summaryGraph';
import { orders } from 'features/dashboard/redux/reducers/orders';

const dashboardReducer = combineReducers({
  ordersGraph,
  redemptionsGraph,
  summaryReducer,
  orders,
});

export type DashboardReducerState = Parameters<typeof dashboardReducer>[0];

export default dashboardReducer;
